import { SetStateAction } from 'react';
import { NavigateFunction } from 'react-router-dom';

import { AppDispatch } from '../../../../store/models/app-dispatch.model';
import { CampaignResponseModel } from '../../models/campaign-response.model';
import { getCampaignById } from '../../thunks/get-campaign-by-id.thunk';

export const populateCampaignDetailsFields = async <TFormikModel>(
  dispatch: AppDispatch,
  campaignId: number,
  setFormValues: (
    values: SetStateAction<TFormikModel>,
    shouldValidate?: boolean | undefined
  ) => void,
  navigate: NavigateFunction,
  campaignFormResponseModelToFormik: (
    data: CampaignResponseModel
  ) => TFormikModel
): Promise<void> => {
  try {
    const formData = await dispatch(getCampaignById({ campaignId })).unwrap();

    setFormValues(campaignFormResponseModelToFormik(formData));
  } catch {
    navigate('/campaign-management/campaigns');
  }
};
